import "@css/app.css";
import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import hljs from "highlight.js";
import "highlight.js/styles/github-dark.css";
import initHero from "./components/hero.js";

window.Alpine = Alpine;

// Register Alpine plugins
Alpine.plugin(focus);

Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("pre code").forEach((block) => {
    hljs.highlightElement(block);
  });

  // Hero-Komponente initialisieren
  initHero();

  // Editor-eingefügte iFrame-Embeds ohne eigenen Titel nachträglich beschriften
  document.querySelectorAll("[data-embed-title] iframe:not([title])").forEach((iframe) => {
    iframe.title = iframe.closest("[data-embed-title]").dataset.embedTitle;
  });
});
